import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { endpoints } from '@shared/endpoints';

@Injectable({
    providedIn: 'root',
})
export class AsyncValidatorsService {
    constructor(private http: HttpClient) {}

    validateUsername(username: string) {
        return this.http.head<void>(
            endpoints.identity.children.getValidateUsernameUrl(username)
        );
    }

    validateEmail(email: string) {
        return this.http.head<void>(
            endpoints.identity.children.getValidateEmailUrl(email)
        );
    }
}
